__turbopack_context__.v({
  "iframe": "ArticleModuleEmbed-module-scss-module__n594Ua__iframe",
  "link": "ArticleModuleEmbed-module-scss-module__n594Ua__link",
  "noMargin": "ArticleModuleEmbed-module-scss-module__n594Ua__noMargin",
  "overlay": "ArticleModuleEmbed-module-scss-module__n594Ua__overlay",
  "root": "ArticleModuleEmbed-module-scss-module__n594Ua__root",
  "wrapper": "ArticleModuleEmbed-module-scss-module__n594Ua__wrapper",
});
